import { createContext, useContext } from 'react';
import type { UserRole, UserAccessStatus } from '../types';

export interface UserRoleCtx {
  role:    UserRole         | null;
  status:  UserAccessStatus | null;
  isAdmin: boolean;
  userId:  string | null;
  email:   string | null;
  name:    string | null;
}

const UserRoleContext = createContext<UserRoleCtx>({
  role:    null,
  status:  null,
  isAdmin: false,
  userId:  null,
  email:   null,
  name:    null,
});

export function useUserRole() {
  return useContext(UserRoleContext);
}

export default UserRoleContext;
